<div class="card shadow p-4 min-h-[270px] overflow-visible" style="overflow: visible !important;">
  <nz-skeleton
    [ngClass]="loading ? 'p-3' : 'p-0'"
    [nzLoading]="loading"
    [nzActive]="true"
  >
    <div class="flex flex-col md:flex-row justify-between items-center gap-1">
      <span class="text-black title">Payment Service</span>
      <div
        class="border rounded py-0 px-1 d-flex flex-row"
      >
        <input
          type="text"
          class="btn p-0 date-pick w-100 lg:w-[617px]"
          ngxDaterangepickerMd
          [(ngModel)]="selected"
          [ngModelOptions]="{ standalone: true }"
          [showCustomRangeLabel]="true"
          [keepCalendarOpeningWithRange]="true"
          [alwaysShowCalendars]="true"
          [ranges]="ranges"
          [linkedCalendars]="true"
          [isInvalidDate]="isInvalidDate"
          [showCancel]="true"
          [showRangeLabelOnInput]="true"
          opens="left"
          drops="down"
          [locale]="setlocale"
          (datesUpdated)="onChangeDate($event)"
          style="border: none; font-size: 14px;overflow: auto !important;"
          #datePickerInput
        />
        <div class="p-2 ngx-daterangepicker-action">
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar.svg"
            alt="calendar"
          />
        </div>
      </div>
    </div>
    <hr>
    <div class="flex flex-col md:flex-row items-center gap-1 w-full mt-2">
      <app-stat-card *ngFor="let card of cardsPayment" [card]="card" class="col-12 col-md-6"></app-stat-card>
    </div>
  </nz-skeleton>
</div>
